const PLACEHOLDER_VIDEO_URL =
  "https://s3.us-east-1.amazonaws.com/ops4.5-prod-bucket/file_example_MP4_640_3MG.mp4";

/** Same pattern as sally-odometer-ui `src/api/constants/url.const.api.js` */
const apiBaseUrl = () => {
  const raw = process.env.REACT_APP_API_URL;
  if (!raw || typeof raw !== "string") {
    return "http://localhost:8000/api";
  }
  return raw.replace(/\/+$/, "");
};

const joinApiPath = (path) => {
  const base = apiBaseUrl();
  const segment = path.startsWith("/") ? path : `/${path}`;
  return `${base}${segment}`;
};

const COACHING_GET_PATH = "/drivers/motive/coaching_video_url/";
const COACHING_POST_PATH = "/drivers/motive/coaching_completed/";

function buildCoachingGetUrl(token) {
  const url = new URL(joinApiPath(COACHING_GET_PATH));
  url.searchParams.set("token", token ?? "");
  return url.toString();
}

function parseCoachingUrlFromResponse(data) {
  if (!data || typeof data !== "object") {
    return null;
  }
  const fromCoaching =
    typeof data.coaching_url === "string" && data.coaching_url ? data.coaching_url : null;
  const legacy =
    typeof data.video_url === "string" && data.video_url
      ? data.video_url
      : typeof data.url === "string" && data.url
        ? data.url
        : typeof data.s3_url === "string" && data.s3_url
          ? data.s3_url
          : null;
  return fromCoaching || legacy;
}

export async function fetchCoachingVideoUrl(token) {
  try {
    const response = await fetch(buildCoachingGetUrl(token), {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error("Video URL endpoint returned non-2xx response");
    }

    const data = await response.json();
    const url = parseCoachingUrlFromResponse(data);
    return url || PLACEHOLDER_VIDEO_URL;
  } catch (_error) {
    return PLACEHOLDER_VIDEO_URL;
  }
}

export async function postCoachingFinished(token) {
  const payload = {
    token: token ?? ""
  };

  try {
    await fetch(joinApiPath(COACHING_POST_PATH), {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });
  } catch (_error) {
    // Placeholder endpoint handling for now.
  }
}

export { PLACEHOLDER_VIDEO_URL, apiBaseUrl };
